import Sloth from "../../components/Sloth";

@Sloth.component({
    defaultOptions: {}
})

export default class XueLiCourseList {


    constructor() {
        this.type = ''
    }

    onInit() {
        const self = this
        const dom = this.dom

        $(".XueLiCourseList-filter", this.dom).prepend("<div class='XueLiCourseList-filter-label'></div>")

        $(".XueLiCourseList-filter", dom).on("click", 'button', function () {
            self.type = $(this).data("type");
            self.render()
            $(".XueLiCourseList-filter", this.dom).removeClass("open")
        })

        $(this.dom).on("click", '.XueLiCourseList-filter-label',  () => {
            $(".XueLiCourseList-filter", this.dom).toggleClass("open")
        })

        $(document.body).on("click", (e) => {
           if($(e.target).parents(".XueLiCourseList-filter").length === 0){
               $(".XueLiCourseList-filter", this.dom).removeClass("open")
           }
        })

        this.type = $(".XueLiCourseList-filter", this.dom).data('value')
        self.render()
    }

    get typeList() {
        const data = [];

        $(".XueLiCourseList-filter button", this.dom).each((index, item) => {
            const value = $(item).data("type");
            const label = $(item).text();
            data.push({value, label});
        })
        return data
    }

    get currentData() {
        return this.typeList.find(item => item.value === this.type);
    }

    filterList() {
        const dom = this.dom
        const type = this.type

        $(".CourseCard", dom).each(function (index, item) {
            if(type && type !== $(item).data("type")) {
                $(item).parent().hide()
            } else {
                $(item).parent().show()
            }
        })

        $(".XueLiCourseList-filter-label", this.dom).text(this.currentData.label);
    }

    render() {
        $(".XueLiCourseList-filter button", this.dom).each((index, item) => {
            const type = $(item).data('type')
            if(type === this.type) $(item).addClass("current")
            else $(item).removeClass("current")
        })

        $(".XueLiCourseList-filter", this.dom).data("value", this.type)
        this.filterList()
    }
}


/** WEBPACK FOOTER **
 ** ./src/XueLiJiaoYu/XueLiCourseList.js
 **/